import React from "react";
import PropTypes from "prop-types";

import Collapse from "@kunukn/react-collapse";
import { FIXED_POINT, formatRounded } from "../../services/numbers";

import DisplayValue from "../DisplayValue";
import { useModal } from "hooks";
import CollapsedContentTabs from "./CollapsedContentTabs";

import { ReactComponent as HeraPoolIcon } from "../../assets/svg/hera-pool.svg";
import { ReactComponent as PlutusPoolIcon } from "../../assets/svg/plutus-pool.svg";

import { ButtonIcon } from "@airdao/ui-library";
import { ReactComponent as Chevron } from "../../assets/svg/chevron.svg";
import { useAccount } from "wagmi";

const StakingItem = ({
  expand = false,
  activeExpand,
  setActiveExpand,
  state = 0,
  dispatch,
  index = -1,
  poolInfo,
}) => {
  const {
    myStakeInAMB,
    active: isPoolActive,
    contractName,
    totalStakeInAMB,
    poolAPY,
  } = poolInfo;

  const { chainId, isConnected: isActive } = useAccount();
  const isReady = isActive && chainId === +process.env.REACT_APP_CHAIN_ID;

  const { toggle: toggleLogInMethodShow } = useModal();

  const stakeBtnHandler = () => {
    if (expand !== false) {
      setActiveExpand(index);
      dispatch({ type: "toggle", index });
      if (index === activeExpand) {
        dispatch({ type: "hide", index });
      }
      if (index === activeExpand && !state[index]) {
        dispatch({ type: "toggle", index });
      }
    } else {
      toggleLogInMethodShow();
    }
  };

  const isOpen = state[index] && activeExpand === index;

  return (
    <div
      role="presentation"
      className={`pool ${isPoolActive ? "pool_inactive" : ""} `}
      style={{
        color: !myStakeInAMB ? "rgb(191 201 224)" : "inherit",
      }}
    >
      <div className="pool__info pools__grid" role="presentation">
        <div className="pool__title">
          <PoolToken
            name={contractName && contractName.substring(0, 8)}
            className="pool__icon"
          />
          <p className="pool__name">
            {contractName && contractName.substring(0, 8)}
          </p>
        </div>

        <div className="pool__currently-staking">
          <DisplayValue
            value={
              myStakeInAMB && (isReady ? formatRounded(myStakeInAMB, 2) : "0.0")
            }
          />
        </div>

        <div className="pool__total-staked">
          <DisplayValue
            value={totalStakeInAMB && formatRounded(totalStakeInAMB, 2)}
          />
        </div>

        <div className="pool__apy">
          <DisplayValue
            symbol={"% APY"}
            noSpace
            value={
              !isPoolActive && totalStakeInAMB.gte(FIXED_POINT)
                ? "0.0"
                : poolAPY
            }
          />
        </div>

        {window.innerWidth > 1000 && (
          <ButtonIcon
            type="tetiary"
            size={40}
            className={`pool__toggle-button ${
              isOpen ? "pool__toggle-button_open" : ""
            }`}
            onClick={stakeBtnHandler}
          >
            <Chevron />
          </ButtonIcon>
        )}
      </div>

      <Collapse isOpen={state[index] ? activeExpand === index : state[index]}>
        <div className="pool__collapsed">
          <div className="pool__collapsed-content">
            <CollapsedContentTabs poolInfo={poolInfo} />
          </div>
        </div>
      </Collapse>

      <div className="pool__mobile-toggle">
        <button
          className={`pool__mobile-toggle-button ${
            isOpen ? "pool__mobile-toggle-button_open" : ""
          }`}
          onClick={stakeBtnHandler}
        >
          <Chevron />
        </button>
      </div>
    </div>
  );
};

StakingItem.propTypes = {
  poolInfo: PropTypes.object,
  dispatch: PropTypes.func,
  expand: PropTypes.bool,
  state: PropTypes.array,
  index: PropTypes.number,
  activeExpand: PropTypes.number,
  setActiveExpand: PropTypes.func,
};
export default React.memo(StakingItem);

function PoolToken({ name, ...props }) {
  switch (name) {
    case "Hera":
      return <HeraPoolIcon {...props} />;
    case "Plutus":
      return <PlutusPoolIcon {...props} />;
    default:
      return <PlutusPoolIcon {...props} />;
  }
}
